<template>
	<ul class="nav navbar-top-links navbar-right">
		<li>
			<span id="user_email">{{email}}</span>
		</li>
		<li>
			<button type="button" class="btn btn-secondary" @click="logout()">Logout</button>
		</li>
	</ul>
	<!--ul class="nav navbar-top-links navbar-right">
		<li class="dropdown">
			<a class="dropdown-toggle" data-toggle="dropdown" href="#">
				<i class="fa fa-user fa-fw"></i>
				<i class="fa fa-caret-down"></i>
			</a>
			<ul class="dropdown-menu dropdown-user">
				<li>
					<a href="#">
						<i class="fa fa-user fa-fw"></i> User Profile</a>
				</li>
				<li>
					<a href="#">
						<i class="fa fa-gear fa-fw"></i> Settings</a>
				</li>
				<li class="divider"></li>
				<li>
					<a href="#" @click="logout()">
						<i class="fa fa-sign-out fa-fw"></i> Logout</a>
				</li>
			</ul>
		</li>
	</ul-->
</template>


<script>
const auth = require("@/utils/auth");
const logger = require("@/utils/logger");
import router from "@/router";

export default {
  data() {
    return {
      email: ""
    };
  },
  methods: {
    logout() {
      logger.log("Logging out");
      auth.deleteSession();
      auth.logout();
      //router.push("/");
    }
  },
  mounted() {
    this.email = auth.getAuthenticatedUserEmail();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  height: 100%;
  display: flex;
  align-items: center;
  color: #777;
  justify-content: flex-end;
}
.navbar-top-links li {
  margin: 0 0 0 15px;
}
.btn-secondary {
  fill: transparent;
  background: transparent;
  border-color: #a4abbd;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AuthenticatedAppHeader.vue